import mainCaller from './mainCaller';

const BASE = 'admin/api/v1/member-app-links';

// 지점 요청 목록. status 생략 시 전체.
export async function getMemberAppLinks(branchId, status) {
  const query = status ? `branchId=${branchId}&status=${status}` : `branchId=${branchId}`;
  return await mainCaller(`${BASE}?${query}`, 'GET', null, {});
}

// 회원·잠재회원 한 명의 연동 이력 (최신순)
export async function getMemberAppLinkHistory({ targetMemberId, targetTemporaryUserId }) {
  const query = targetMemberId
    ? `targetMemberId=${targetMemberId}`
    : `targetTemporaryUserId=${targetTemporaryUserId}`;
  return await mainCaller(`${BASE}?${query}`, 'GET', null, {});
}

// 메뉴 뱃지용 대기 건수. 응답 {count}
export async function getMemberAppLinkPendingCount(branchId) {
  return await mainCaller(`${BASE}/pending-count?branchId=${branchId}`, 'GET', null, {});
}

// 아이디 전부 일치만(전화번호 검색 없음, 2026-10-22)
export async function searchMemberAppLinkAccounts({ username }) {
  return await mainCaller(`${BASE}/app-users?username=${encodeURIComponent(username)}`, 'GET', null, {});
}

// target: {targetType, targetMemberId | targetTemporaryUserId}
export async function approveMemberAppLink(id, target) {
  return await mainCaller(`${BASE}/${id}/approve`, 'PUT', target, {});
}

// 이 앱 계정이 예전에 이 지점과 연동했던 기록·그때 대상. 응답 {linkedBefore, lastLinkedAt, lastUnlinkedAt, target}
export async function getMemberAppLinkPreviousTarget(id) {
  return await mainCaller(`${BASE}/${id}/previous-target`, 'GET', null, {});
}

// 앱 계정이 휴대폰 인증한 번호와 같은 번호로 이 지점에 등록된 회원(인증 안 했으면 빈 목록)
export async function getMemberAppLinkSamePhoneCandidates(id) {
  return await mainCaller(`${BASE}/${id}/same-phone-candidates`, 'GET', null, {});
}

export async function rejectMemberAppLink(id) {
  return await mainCaller(`${BASE}/${id}/reject`, 'PUT', null, {});
}

export async function directMemberAppLink(body) {
  return await mainCaller(`${BASE}/direct`, 'POST', body, {});
}

// 연동 취소 — 기록만 바뀌고 데이터는 그대로다
export async function unlinkMemberAppLink(id) {
  return await mainCaller(`${BASE}/${id}/unlink`, 'PUT', null, {});
}

// 초대 취소 — 회원이 아직 동의하기 전의 초대만 취소된다
export async function cancelInviteMemberAppLink(id) {
  return await mainCaller(`${BASE}/${id}/cancel-invite`, 'PUT', null, {});
}

// CRM 회원에 앱 아이디·비밀번호를 부여한다 (신규 가입)
export async function setMemberAppAccount(memberId, body) {
  return await mainCaller(`${BASE}/members/${memberId}/account`, 'PUT', body, {});
}

// 지점 앱 연동 QR 조회 (없으면 생성). 응답 {branchId, branchName, qrText}
export async function getMemberAppLinkQr(branchId) {
  return await mainCaller(`${BASE}/qr?branchId=${branchId}`, 'GET', null, {});
}

// QR 재발급 — 이전 QR 은 더 이상 연동되지 않는다
export async function reissueMemberAppLinkQr(branchId) {
  return await mainCaller(`${BASE}/qr/reissue?branchId=${branchId}`, 'POST', null, {});
}

// 지점 자동 승인 설정(#195). 응답 {branchId, enabled, pendingCount}
export async function getMemberAppLinkAutoApprove(branchId) {
  return await mainCaller(`${BASE}/auto-approve?branchId=${branchId}`, 'GET', null, {});
}

export async function setMemberAppLinkAutoApprove(branchId, enabled) {
  return await mainCaller(`${BASE}/auto-approve?branchId=${branchId}`, 'PUT', { enabled }, {});
}

// 기존 대기 요청 미리보기(바꾸지 않음). 응답 {total, approvable[], needsReview[]}
export async function previewMemberAppLinkAutoApprove(branchId) {
  return await mainCaller(`${BASE}/auto-approve/preview?branchId=${branchId}`, 'GET', null, {});
}

// 기존 대기 요청 자동 승인 처리. 응답 {total, approvable[](승인됨), needsReview[]}
export async function processMemberAppLinkAutoApprove(branchId) {
  return await mainCaller(`${BASE}/auto-approve/process?branchId=${branchId}`, 'POST', null, {});
}
